import ContentRoutes from 'ContentUtils/Routes';
import PortalIdParser from 'PortalIdParser';
import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
const getBaseUrl = () => '/knowledge-article';
const getBaseAppUrl = rootSlug => {
  const portalId = PortalIdParser.get();
  return `${getFullUrlWithCurrentSubDomain()}/${rootSlug}/${portalId}`;
};
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const getSettingsUrl = groupId => `/service-hub-settings/${PortalIdParser.get()}/${groupId}/knowledge`;
export const getEditCategoryTranslationsUrl = groupId => `/knowledge/${PortalIdParser.get()}/${groupId}/organize`;
export const getEditorUrl = articleId => `${getRootUrl()}/editor/${articleId}/content`;
export const getKnowledgeBaseManageUrl = knowledgeBaseId => {
  return `${getBaseAppUrl('knowledge')}/${knowledgeBaseId}`;
};
export const getThemeSettingsEditorUrl = themeSettingsOrKBId => {
  return ContentRoutes.themeEditor('@hubspot/cms-knowledge-base-theme', {
    themeVariant: themeSettingsOrKBId,
    fromAppName: 'knowledgeBase',
    redirectUrl: window.location.pathname
  });
};
export const getKnowledgeArticleDetailsUrl = articleId => {
  return `${getBaseAppUrl('knowledge')}/insights/article/${articleId}/performance`;
};
export const getKnowledgeArticlePublishedUrl = articleId => {
  return `${getBaseAppUrl('knowledge')}/insights/article/${articleId}/published`;
};
export const getListsUrl = () => `/lists/${PortalIdParser.get()}`;